export enum FormCategory {
  MEDICATION = 'medication',
  NUTRITION = 'nutrition',
  SLEEP = 'sleep',
  OTHER = 'other',
}

export const CATEGORY_OPTIONS = [
  { value: FormCategory.MEDICATION, label: 'medication' },
  { value: FormCategory.NUTRITION, label: 'nutrition' },
  { value: FormCategory.SLEEP, label: 'sleep' },
  { value: FormCategory.OTHER, label: 'other' },
]

export const getCategoryLabel = (category: string): string => {
  return Object.values(FormCategory).includes(category as FormCategory)
    ? (category as FormCategory)
    : FormCategory.OTHER
}
